<template>
    <div>
        <v-container>
            <loading :active="isLoading" :is-full-page="true" :lock-scroll="true" loader="dots" color="#0168b7"
                background-color="#ffffff" opacity="1" />

            <div v-show="!isLoading">
                <h2 class="ma-0">
                    {{ title }}
                </h2>
                <div>
                    {{ author }}
                </div>
                <div>
                    {{ formatDate(datetime) }}
                </div>
                <v-divider class="my-3" />
                <div class="my-4" v-if="this.$route.query.showSnsShare">
                    <sns-share :url="shareUrl" :align="`right`" />
                </div>
                <div class="cms-container" v-html="text" />
            </div>
        </v-container>
    </div>
</template>

<style scoped>
@import "../assets/css/cms.css";
</style>

<script>
import axios from "axios";
import Loading from 'vue3-loading-overlay';
import SnsShare from "../components/SnsShare.vue";
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import helper from "../assets/js/helper";

export default {
    props: [
    ],
    components: {
        Loading,
        SnsShare
    },
    data: () => ({
        isLoading: true,
        'source_uri': '',
        'title': '',
        'datetime': '',
        'text': '',
        shareUrl: window.location.href,
    }),
    computed: {
    },
    created() {
        this.source_uri = this.$route.query.source_uri
    },
    // コンポーネントマウントリスナ
    mounted() {
        this.fetchContent();
    },
    watch: {
        title(to) {
            if( to ){
                this.$store.dispatch('setActivePageTitle', to)
                console.log('component title setted ', to)
            }
        },
    },
    methods: {
        async fetchContent() {

            const res = await axios.get(this.source_uri).catch((error) => {
                console.error(error)
                return;
            });

            this.title = res.data.title;
            this.datetime = res.data.posting_datetime;
            this.text = res.data.text;
            this.author = res.data.author;

            this.$nextTick(() => {
                this.isLoading = false
            })

        },
        formatDate(string){
            if(!string) return ''
            return helper.formatDate(string)
        }
    }
}
</script>